export default __webpack_public_path__ + "static/media/contact.e60221a5.jpg";